// import React, { useContext, useEffect, useMemo, useState } from 'react';
// import { Navigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';
// import {
//     getUsers,
//     createUser,
//     updateUser,
//     deleteUser,
//     changePassword,
// } from '../api/users';
// import { User, CreateUserRequest, UpdateUserRequest } from '../types/user';
// import UserForm from '../components/UserForm';
// import EditUserForm from '../components/EditUserForm';
// import ChangePasswordForm from '../components/ChangePasswordForm';

// import {
//     Plus, Edit3, RotateCcw, Trash2,
//     Search, ChevronDown, Users as UsersIcon,
//     Shield, User as UserIcon, Eye
// } from 'lucide-react';

// import Sidebar from '../components/Sidebar';
// import '../styles/Users.css';

// export default function Users() {
//     const { user: currentUser } = useContext(AuthContext);

//     const [users, setUsers] = useState<User[]>([]);
//     const [loading, setLoading] = useState(true);

//     const [showCreate, setShowCreate] = useState(false);
//     const [editTarget, setEditTarget] = useState<User | null>(null);
//     const [pwdTarget, setPwdTarget] = useState<User | null>(null);

//     const [searchTerm, setSearchTerm] = useState('');
//     const [filterRole, setFilterRole] = useState<'all' | 'superadmin' | 'admin' | 'viewer'>('all');

//     useEffect(() => {
//         let mounted = true;
//         (async () => {
//             try {
//                 const data = await getUsers();
//                 if (mounted) setUsers(data);
//             } finally {
//                 if (mounted) setLoading(false);
//             }
//         })();
//         return () => { mounted = false; };
//     }, []);

//     // Admins can only see viewers; superadmin sees all
//     const visibleUsers = useMemo(
//         () => currentUser?.role === 'admin'
//             ? users.filter(u => u.role === 'viewer')
//             : users
//         ,
//         [users, currentUser]
//     );

//     const filteredUsers = useMemo(() => {
//         const q = searchTerm.toLowerCase();
//         return visibleUsers.filter(u => {
//             const matchesSearch =
//                 u.email.toLowerCase().includes(q) ||
//                 u.username.toLowerCase().includes(q);
//             const matchesRole = filterRole === 'all' || u.role === filterRole;
//             return matchesSearch && matchesRole;
//         });
//     }, [visibleUsers, searchTerm, filterRole]);

//     // viewer → bounce to dashboard
//     if (currentUser?.role === 'viewer') return <Navigate to="/dashboard" replace />;

//     const allowedRoles: ('admin' | 'viewer')[] =
//         currentUser?.role === 'superadmin' ? ['admin', 'viewer'] : ['viewer'];

//     // handlers
//     const handleCreate = async (data: CreateUserRequest) => {
//         const u = await createUser(data);
//         setUsers(prev => [u, ...prev]);
//         setShowCreate(false);
//     };
//     const handleUpdate = async (id: string, data: UpdateUserRequest) => {
//         const u = await updateUser(id, data);
//         setUsers(prev => prev.map(x => (x.id === id ? u : x)));
//         setEditTarget(null);
//     };
//     const handleDelete = async (id: string) => {
//         if (!window.confirm('Delete this user?')) return;
//         await deleteUser(id);
//         setUsers(prev => prev.filter(x => x.id !== id));
//     };
//     const handleChangePassword = async (id: string, np: string) => {
//         await changePassword(id, np);
//         setPwdTarget(null);
//         alert('Password updated');
//     };

//     const canEditUser = (u: User) =>
//         currentUser?.role === 'superadmin' ||
//         (currentUser?.role === 'admin' && u.role === 'viewer');

//     const canDeleteUser = (u: User) =>
//         currentUser?.role === 'superadmin' && u.role !== 'superadmin';

//     const canResetPwd = currentUser?.role === 'superadmin';

//     const getRoleIcon = (role: string) => {
//         switch (role) {
//             case 'superadmin': return <Shield className="icon" />;
//             case 'admin':      return <UserIcon className="icon" />;
//             case 'viewer':     return <Eye className="icon" />;
//             default:           return <UserIcon className="icon" />;
//         }
//     };

//     const getInitials = (email: string, username: string) => {
//         const root = email.split('@')[0] || username;
//         return root.slice(0, 2).toUpperCase();
//     };

//     const formatDate = (d?: string | Date) => {
//         if (!d) return '—';
//         const dt = new Date(d);
//         // yyyy-mm-dd to match screenshot
//         return dt.toLocaleDateString('en-CA');
//     };

//     return (
//         <div className="users-page">
//             <Sidebar />
//             <main className="main-container">
//                 <header className="page-header">
//                     <div className="title-wrap">
//                         <span className="title-icon"><UsersIcon size={22} /></span>
//                         <div>
//                             <h1 className="title">User Management</h1>
//                             <p className="subtitle">Manage system users and their permissions</p>
//                         </div>
//                     </div>
//                     <button className="btn-primary" onClick={() => setShowCreate(true)}>
//                         <Plus size={18} /> New User
//                     </button>
//                 </header>

//                 {/* search + role filter bar */}
//                 <section className="filter-bar">
//                     <div className="search-input-wrapper">
//                         <Search className="search-icon" size={18} />
//                         <input
//                             type="text"
//                             placeholder="Search users by email or username"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="search-input"
//                         />
//                     </div>

//                     <div className="role-select-wrap">
//                         <select
//                             className="role-select"
//                             value={filterRole}
//                             onChange={(e) => setFilterRole(e.target.value as any)}
//                         >
//                             <option value="all">All Roles</option>
//                             <option value="superadmin">Super Admin</option>
//                             <option value="admin">Admin</option>
//                             <option value="viewer">Viewer</option>
//                         </select>
//                         <ChevronDown className="select-caret" size={16} />
//                     </div>
//                 </section>

//                 {/* users table card */}
//                 <section className="card">
//                     <div className="card-head">
//                         <h2>Users <span className="muted">({filteredUsers.length})</span></h2>
//                     </div>

//                     {loading ? (
//                         <div className="loading">Loading…</div>
//                     ) : (
//                         <div className="table-wrap">
//                             <table className="users-table">
//                                 <thead>
//                                 <tr>
//                                     <th>User</th>
//                                     <th>Role</th>
//                                     <th>Created By</th>
//                                     <th>Created Date</th>
//                                     <th className="th-actions">Actions</th>
//                                 </tr>
//                                 </thead>
//                                 <tbody>
//                                 {filteredUsers.map(u => (
//                                     <tr key={u.id}>
//                                         <td>
//                                             <div className="cell-user">
//                                                 <div className="avatar">{getInitials(u.email, u.username)}</div>
//                                                 <div>
//                                                     <div className="email">{u.email}</div>
//                                                     <div className="username">@{u.username}</div>
//                                                 </div>
//                                             </div>
//                                         </td>
//                                         <td>
//                         <span className={`badge ${u.role}`}>
//                           {getRoleIcon(u.role)} {u.role === 'superadmin' ? 'Super Admin' : u.role[0].toUpperCase() + u.role.slice(1)}
//                         </span>
//                                         </td>
//                                         <td><span className="created-by">{u.createdBy?.username ?? 'System'}</span></td>
//                                         <td className="date-cell">{formatDate((u as any).createdAt)}</td>
//                                         <td>
//                                             <div className="actions">
//                                                 {canEditUser(u) && (
//                                                     <button className="action-btn" title="Edit user" onClick={() => setEditTarget(u)}>
//                                                         <Edit3 size={18} />
//                                                     </button>
//                                                 )}
//                                                 {canResetPwd && (
//                                                     <button className="action-btn action-green" title="Reset password" onClick={() => setPwdTarget(u)}>
//                                                         <RotateCcw size={18} />
//                                                     </button>
//                                                 )}
//                                                 {canDeleteUser(u) && (
//                                                     <button className="action-btn action-red" title="Delete user" onClick={() => handleDelete(u.id)}>
//                                                         <Trash2 size={18} />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}
//                 </section>

//                 {/* Modals */}
//                 {showCreate && (
//                     <UserForm
//                         onSubmit={handleCreate}
//                         onCancel={() => setShowCreate(false)}
//                         allowedRoles={allowedRoles}
//                     />
//                 )}
//                 {editTarget && (
//                     <EditUserForm
//                         user={editTarget}
//                         onSubmit={handleUpdate}
//                         onCancel={() => setEditTarget(null)}
//                         allowedRoles={allowedRoles}
//                         isSelfEdit={currentUser?.id === editTarget.id}
//                     />
//                 )}
//                 {pwdTarget && (
//                     <ChangePasswordForm
//                         userId={pwdTarget.id}
//                         username={pwdTarget.username}
//                         onSubmit={handleChangePassword}
//                         onCancel={() => setPwdTarget(null)}
//                     />
//                 )}
//             </main>
//         </div>
//     );
// }

import React, { useContext, useEffect, useMemo, useState } from "react";

import { Navigate } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

import {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  changePassword,
} from "../api/users";

import { User, CreateUserRequest, UpdateUserRequest } from "../types/user";

import UserForm from "../components/UserForm";
import EditUserForm from "../components/EditUserForm";
import ChangePasswordForm from "../components/ChangePasswordForm";

import {
  Plus,
  Pencil,
  KeyRound,
  Trash2,
  Search,
  ChevronDown,
  Users as UsersIcon,
  ShieldCheck,
  UserCog,
  Eye,
  X,
} from "lucide-react";

import Sidebar from "../components/Sidebar";

/* =========================================================
   TYPES
========================================================= */

type RoleFilter = "all" | "superadmin" | "admin" | "viewer";

/* =========================================================
   COMPONENT
========================================================= */

export default function Users() {
  const { user: currentUser } = useContext(AuthContext);

  /* =====================================================
       DATA STATE
    ===================================================== */

  const [users, setUsers] = useState<User[]>([]);

  const [loading, setLoading] = useState(true);

  /* =====================================================
       MODAL STATE
    ===================================================== */

  const [showCreate, setShowCreate] = useState(false);

  const [editTarget, setEditTarget] = useState<User | null>(null);

  const [pwdTarget, setPwdTarget] = useState<User | null>(null);

  /* =====================================================
       FILTER STATE
    ===================================================== */

  const [searchTerm, setSearchTerm] = useState("");

  const [filterRole, setFilterRole] = useState<RoleFilter>("all");

  /* =====================================================
       LOAD USERS
    ===================================================== */

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const data = await getUsers();

        if (mounted) {
          setUsers(data);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  /* =====================================================
       ROLE VISIBILITY
    ===================================================== */

  const visibleUsers = useMemo(
    () =>
      currentUser?.role === "admin"
        ? users.filter((user) => user.role === "viewer")
        : users,
    [users, currentUser],
  );

  /* =====================================================
       FILTERED USERS
    ===================================================== */

  const filteredUsers = useMemo(() => {
    const query = searchTerm.trim().toLowerCase();

    return visibleUsers.filter((user) => {
      const matchesSearch =
        user.email.toLowerCase().includes(query) ||
        user.username.toLowerCase().includes(query);

      const matchesRole = filterRole === "all" || user.role === filterRole;

      return matchesSearch && matchesRole;
    });
  }, [visibleUsers, searchTerm, filterRole]);

  /* =====================================================
       VIEWER ACCESS
    ===================================================== */

  if (currentUser?.role === "viewer") {
    return <Navigate to="/dashboard" replace />;
  }

  /* =====================================================
       ALLOWED CREATE/EDIT ROLES
    ===================================================== */

  const allowedRoles: ("admin" | "viewer")[] =
    currentUser?.role === "superadmin" ? ["admin", "viewer"] : ["viewer"];

  /* =====================================================
       HANDLERS
    ===================================================== */

  const handleCreate = async (data: CreateUserRequest) => {
    const created = await createUser(data);

    setUsers((current) => [created, ...current]);

    setShowCreate(false);
  };

  const handleUpdate = async (id: string, data: UpdateUserRequest) => {
    const updated = await updateUser(id, data);

    setUsers((current) =>
      current.map((user) => (user.id === id ? updated : user)),
    );

    setEditTarget(null);
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Delete this user?")) {
      return;
    }

    await deleteUser(id);

    setUsers((current) => current.filter((user) => user.id !== id));
  };

  const handleChangePassword = async (id: string, newPassword: string) => {
    await changePassword(id, newPassword);

    setPwdTarget(null);

    alert("Password updated");
  };

  /* =====================================================
       PERMISSIONS
    ===================================================== */

  const canEditUser = (user: User) =>
    currentUser?.role === "superadmin" ||
    (currentUser?.role === "admin" && user.role === "viewer");

  const canDeleteUser = (user: User) =>
    currentUser?.role === "superadmin" && user.role !== "superadmin";

  const canResetPwd = currentUser?.role === "superadmin";

  /* =====================================================
       UI HELPERS
    ===================================================== */

  const getRoleIcon = (role: string) => {
    switch (role) {
      case "superadmin":
        return <ShieldCheck size={14} strokeWidth={2} />;

      case "admin":
        return <UserCog size={14} strokeWidth={2} />;

      case "viewer":
        return <Eye size={14} strokeWidth={2} />;

      default:
        return <UserCog size={14} strokeWidth={2} />;
    }
  };

  const getRoleLabel = (role: string) => {
    if (role === "superadmin") {
      return "Super Admin";
    }

    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  const getRoleClasses = (role: string) => {
    switch (role) {
      case "superadmin":
        return "border-red-200 " + "bg-red-50 " + "text-red-700";

      case "admin":
        return "border-amber-200 " + "bg-amber-50 " + "text-amber-700";

      case "viewer":
        return "border-blue-200 " + "bg-blue-50 " + "text-blue-700";

      default:
        return "border-slate-200 " + "bg-slate-50 " + "text-slate-600";
    }
  };

  const getInitials = (email: string, username: string) => {
    const root = email.split("@")[0] || username;

    return root.slice(0, 2).toUpperCase();
  };

  const formatDate = (value?: string | Date) => {
    if (!value) {
      return "—";
    }

    const date = new Date(value);

    return date.toLocaleDateString("en-CA");
  };

  const actionButtonBase = `
        group
        relative
        grid
        h-8
        w-8
        place-items-center
        rounded-lg
        border
        bg-white
        p-0
        transition
        focus:outline-none
        focus:ring-2
        focus:ring-slate-200
    `;

  /* =====================================================
       RENDER
    ===================================================== */

  return (
    <div
      className="
                min-h-screen
                bg-[#f7f8fb]
            "
    >
      <Sidebar />

      <main
        className="
                    min-h-screen
                    min-w-0
                    ml-[280px]
                    px-6
                    py-6
                    transition-[margin]
                    duration-200

                    [.sidebar-collapsed_&]:ml-[76px]

                    max-lg:ml-[76px]
                    max-lg:px-4
                    max-sm:px-3
                "
      >
        <div
          className="
                        mx-auto
                        w-full
                        max-w-[1600px]
                    "
        >
          {/* =====================================
                        PAGE HEADER
                    ===================================== */}

          <header
            className="
                            mb-5
                            flex
                            items-start
                            justify-between
                            gap-4

                            max-sm:flex-col
                            max-sm:items-stretch
                        "
          >
            <div
              className="
                                flex
                                items-start
                                gap-3
                            "
            >
              <div
                className="
                                    grid
                                    h-10
                                    w-10
                                    shrink-0
                                    place-items-center
                                    rounded-[10px]
                                    bg-slate-100
                                    text-slate-600
                                "
              >
                <UsersIcon size={20} strokeWidth={1.8} />
              </div>

              <div>
                <h1
                  className="
                                        m-0
                                        text-[28px]
                                        font-bold
                                        tracking-[-0.03em]
                                        text-slate-950

                                        max-sm:text-[24px]
                                    "
                >
                  User Management
                </h1>

                <p
                  className="
                                        mb-0
                                        mt-1
                                        text-[12px]
                                        leading-5
                                        text-slate-500
                                    "
                >
                  Manage system users and their permissions.
                </p>
              </div>
            </div>

            <button
              type="button"
              onClick={() => setShowCreate(true)}
              className="
                                inline-flex
                                h-10
                                shrink-0
                                items-center
                                justify-center
                                gap-2
                                rounded-[9px]
                                border-0
                                bg-[#0d162a]
                                px-4
                                text-[12px]
                                font-semibold
                                text-white
                                transition
                                hover:bg-[#172239]
                                focus:outline-none
                                focus:ring-2
                                focus:ring-slate-300

                                max-sm:w-full
                            "
            >
              <Plus size={16} strokeWidth={2} />
              New User
            </button>
          </header>

          {/* =====================================
                        SEARCH + FILTERS
                    ===================================== */}

          <section
            className="
                            mb-4
                            flex
                            items-end
                            gap-3
                            rounded-[16px]
                            border
                            border-slate-200
                            bg-white
                            p-4
                            shadow-[0_1px_3px_rgba(15,23,42,0.04)]

                            max-sm:flex-col
                            max-sm:items-stretch
                        "
          >
            {/* Search */}

            <label
              className="
                                min-w-0
                                flex-1
                            "
            >
              <span
                className="
                                    mb-1.5
                                    block
                                    text-[10px]
                                    font-semibold
                                    uppercase
                                    tracking-[0.04em]
                                    text-slate-400
                                "
              >
                Search users
              </span>

              <div
                className="
                                    relative
                                "
              >
                <Search
                  size={16}
                  strokeWidth={1.8}
                  className="
                                        pointer-events-none
                                        absolute
                                        left-3
                                        top-1/2
                                        -translate-y-1/2
                                        text-slate-400
                                    "
                />

                <input
                  type="text"
                  placeholder="Search by email or username..."
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  className="
                                        box-border
                                        h-10
                                        w-full
                                        rounded-[9px]
                                        border
                                        border-slate-200
                                        bg-white
                                        pl-9
                                        pr-9
                                        text-[12px]
                                        text-slate-900
                                        outline-none
                                        transition
                                        placeholder:text-slate-400
                                        hover:border-slate-300
                                        focus:border-slate-400
                                        focus:ring-2
                                        focus:ring-slate-100
                                    "
                />

                {searchTerm && (
                  <button
                    type="button"
                    aria-label="Clear search"
                    title="Clear search"
                    onClick={() => setSearchTerm("")}
                    className="
                                            absolute
                                            right-2
                                            top-1/2
                                            grid
                                            h-7
                                            w-7
                                            -translate-y-1/2
                                            place-items-center
                                            rounded-md
                                            border-0
                                            bg-transparent
                                            p-0
                                            text-slate-400
                                            transition
                                            hover:bg-slate-100
                                            hover:text-slate-700
                                        "
                  >
                    <X size={14} />
                  </button>
                )}
              </div>
            </label>

            {/* Role */}

            <label
              className="
                                w-[190px]
                                shrink-0

                                max-sm:w-full
                            "
            >
              <span
                className="
                                    mb-1.5
                                    block
                                    text-[10px]
                                    font-semibold
                                    uppercase
                                    tracking-[0.04em]
                                    text-slate-400
                                "
              >
                Role
              </span>

              <div
                className="
                                    relative
                                "
              >
                <select
                  value={filterRole}
                  onChange={(event) =>
                    setFilterRole(event.target.value as RoleFilter)
                  }
                  className="
                                        box-border
                                        h-10
                                        w-full
                                        appearance-none
                                        rounded-[9px]
                                        border
                                        border-slate-200
                                        bg-white
                                        px-3
                                        pr-9
                                        text-[12px]
                                        font-medium
                                        text-slate-700
                                        outline-none
                                        transition
                                        hover:border-slate-300
                                        focus:border-slate-400
                                        focus:ring-2
                                        focus:ring-slate-100
                                    "
                >
                  <option value="all">All Roles</option>

                  <option value="superadmin">Super Admin</option>

                  <option value="admin">Admin</option>

                  <option value="viewer">Viewer</option>
                </select>

                <ChevronDown
                  size={15}
                  strokeWidth={1.8}
                  className="
                                        pointer-events-none
                                        absolute
                                        right-3
                                        top-1/2
                                        -translate-y-1/2
                                        text-slate-400
                                    "
                />
              </div>
            </label>
          </section>

          {/* =====================================
                        USERS TABLE
                    ===================================== */}

          <section
            className="
                            overflow-hidden
                            rounded-[16px]
                            border
                            border-slate-200
                            bg-white
                            shadow-[0_1px_3px_rgba(15,23,42,0.04)]
                        "
          >
            {/* Card header */}

            <div
              className="
                                flex
                                items-center
                                justify-between
                                gap-4
                                border-b
                                border-slate-100
                                px-5
                                py-4

                                max-sm:px-4
                            "
            >
              <div>
                <h2
                  className="
                                        m-0
                                        text-[15px]
                                        font-bold
                                        text-slate-950
                                    "
                >
                  Users
                </h2>

                <p
                  className="
                                        mb-0
                                        mt-1
                                        text-[10px]
                                        text-slate-400
                                    "
                >
                  Showing{" "}
                  <strong
                    className="
                                            font-semibold
                                            text-slate-600
                                        "
                  >
                    {filteredUsers.length}
                  </strong>{" "}
                  of{" "}
                  <strong
                    className="
                                            font-semibold
                                            text-slate-600
                                        "
                  >
                    {visibleUsers.length}
                  </strong>{" "}
                  visible users
                </p>
              </div>

              <span
                className="
                                    inline-flex
                                    h-7
                                    min-w-7
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-slate-100
                                    px-2.5
                                    text-[10px]
                                    font-semibold
                                    text-slate-600
                                "
              >
                {filteredUsers.length}
              </span>
            </div>

            {/* =================================
                            LOADING
                        ================================= */}

            {loading ? (
              <div
                className="
                                    space-y-2
                                    p-4
                                "
              >
                {[1, 2, 3].map((item) => (
                  <div
                    key={item}
                    className="
                                                h-[62px]
                                                animate-pulse
                                                rounded-xl
                                                bg-slate-100
                                            "
                  />
                ))}
              </div>
            ) : filteredUsers.length === 0 ? (
              /* =============================
                               EMPTY STATE
                            ============================= */

              <div
                className="
                                    flex
                                    min-h-[230px]
                                    flex-col
                                    items-center
                                    justify-center
                                    px-6
                                    text-center
                                "
              >
                <div
                  className="
                                        grid
                                        h-11
                                        w-11
                                        place-items-center
                                        rounded-xl
                                        bg-slate-100
                                        text-slate-400
                                    "
                >
                  <UsersIcon size={20} />
                </div>

                <h3
                  className="
                                        mb-0
                                        mt-3
                                        text-[13px]
                                        font-semibold
                                        text-slate-800
                                    "
                >
                  No users found
                </h3>

                <p
                  className="
                                        mb-0
                                        mt-1
                                        max-w-[330px]
                                        text-[10px]
                                        leading-5
                                        text-slate-400
                                    "
                >
                  No users match the current search and role filters.
                </p>
              </div>
            ) : (
              /* =============================
                               TABLE
                            ============================= */

              <div
                className="
                                    w-full
                                    overflow-x-auto
                                "
              >
                <table
                  className="
                                        w-full
                                        min-w-[980px]
                                        border-collapse
                                    "
                >
                  <thead
                    className="
                                            bg-slate-50/80
                                        "
                  >
                    <tr>
                      <th
                        className="
                                                    w-[36%]
                                                    border-b
                                                    border-slate-200
                                                    px-5
                                                    py-3
                                                    text-left
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.04em]
                                                    text-slate-500
                                                "
                      >
                        User
                      </th>

                      <th
                        className="
                                                    w-[16%]
                                                    border-b
                                                    border-slate-200
                                                    px-4
                                                    py-3
                                                    text-left
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.04em]
                                                    text-slate-500
                                                "
                      >
                        Role
                      </th>

                      <th
                        className="
                                                    w-[18%]
                                                    border-b
                                                    border-slate-200
                                                    px-4
                                                    py-3
                                                    text-left
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.04em]
                                                    text-slate-500
                                                "
                      >
                        Created By
                      </th>

                      <th
                        className="
                                                    w-[16%]
                                                    border-b
                                                    border-slate-200
                                                    px-4
                                                    py-3
                                                    text-left
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.04em]
                                                    text-slate-500
                                                "
                      >
                        Created Date
                      </th>

                      <th
                        className="
                                                    w-[150px]
                                                    border-b
                                                    border-slate-200
                                                    px-4
                                                    py-3
                                                    text-right
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.04em]
                                                    text-slate-500
                                                "
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredUsers.map((user) => (
                      <tr
                        key={user.id}
                        className="
                                                        border-b
                                                        border-slate-100
                                                        transition-colors
                                                        last:border-b-0
                                                        hover:bg-slate-50/60
                                                    "
                      >
                        {/* USER */}

                        <td
                          className="
                                                            px-5
                                                            py-3.5
                                                            align-middle
                                                        "
                        >
                          <div
                            className="
                                                                flex
                                                                min-w-0
                                                                items-center
                                                                gap-3
                                                            "
                          >
                            <div
                              className="
                                                                    grid
                                                                    h-9
                                                                    w-9
                                                                    shrink-0
                                                                    place-items-center
                                                                    rounded-full
                                                                    bg-[#0d162a]
                                                                    text-[10px]
                                                                    font-bold
                                                                    tracking-[0.03em]
                                                                    text-white
                                                                "
                            >
                              {getInitials(user.email, user.username)}
                            </div>

                            <div
                              className="
                                                                    min-w-0
                                                                "
                            >
                              <div
                                className="
                                                                        max-w-[390px]
                                                                        truncate
                                                                        text-[12px]
                                                                        font-semibold
                                                                        text-slate-950
                                                                    "
                                title={user.email}
                              >
                                {user.email}
                              </div>

                              <div
                                className="
                                                                        mt-0.5
                                                                        truncate
                                                                        text-[10px]
                                                                        text-slate-400
                                                                    "
                              >
                                @{user.username}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* ROLE */}

                        <td
                          className="
                                                            px-4
                                                            py-3.5
                                                            align-middle
                                                        "
                        >
                          <span
                            className={`
                                                                inline-flex
                                                                items-center
                                                                gap-1.5
                                                                rounded-full
                                                                border
                                                                px-2.5
                                                                py-1
                                                                text-[10px]
                                                                font-semibold

                                                                ${getRoleClasses(
                                                                  user.role,
                                                                )}
                                                            `}
                          >
                            {getRoleIcon(user.role)}

                            {getRoleLabel(user.role)}
                          </span>
                        </td>

                        {/* CREATED BY */}

                        <td
                          className="
                                                            px-4
                                                            py-3.5
                                                            align-middle
                                                        "
                        >
                          <span
                            className="
                                                                text-[11px]
                                                                font-medium
                                                                text-slate-600
                                                            "
                          >
                            {user.createdBy?.username ?? "System"}
                          </span>
                        </td>

                        {/* DATE */}

                        <td
                          className="
                                                            px-4
                                                            py-3.5
                                                            align-middle
                                                        "
                        >
                          <span
                            className="
                                                                whitespace-nowrap
                                                                font-mono
                                                                text-[10px]
                                                                text-slate-500
                                                            "
                          >
                            {formatDate((user as any).createdAt)}
                          </span>
                        </td>

                        {/* ACTIONS */}

                        <td
                          className="
                                                            px-4
                                                            py-3.5
                                                            align-middle
                                                        "
                        >
                          <div
                            className="
                                                                flex
                                                                items-center
                                                                justify-end
                                                                gap-1.5
                                                            "
                          >
                            {/* EDIT */}

                            {canEditUser(user) && (
                              <button
                                type="button"
                                title="Edit user"
                                aria-label={`Edit ${user.username}`}
                                onClick={() => setEditTarget(user)}
                                className={`
                                                                        ${actionButtonBase}
    
                                                                        border-slate-200
                                                                        text-slate-500

                                                                        hover:border-blue-200
                                                                        hover:bg-blue-50
                                                                        hover:text-blue-600
                                                                    `}
                              >
                                <Pencil size={15} strokeWidth={1.9} />
                              </button>
                            )}

                            {/* PASSWORD */}

                            {canResetPwd && (
                              <button
                                type="button"
                                title="Change password"
                                aria-label={`Change password for ${user.username}`}
                                onClick={() => setPwdTarget(user)}
                                className={`
                                                                        ${actionButtonBase}

                                                                        border-slate-200
                                                                        text-slate-500

                                                                        hover:border-amber-200
                                                                        hover:bg-amber-50
                                                                        hover:text-amber-700
                                                                    `}
                              >
                                <KeyRound size={15} strokeWidth={1.9} />
                              </button>
                            )}

                            {/* DELETE */}

                            {canDeleteUser(user) && (
                              <button
                                type="button"
                                title="Delete user"
                                aria-label={`Delete ${user.username}`}
                                onClick={() => handleDelete(user.id)}
                                className={`
                                                                        ${actionButtonBase}

                                                                        border-slate-200
                                                                        text-slate-500

                                                                        hover:border-red-200
                                                                        hover:bg-red-50
                                                                        hover:text-red-600
                                                                    `}
                              >
                                <Trash2 size={15} strokeWidth={1.9} />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        </div>

        {/* =========================================
                    MODALS
                ========================================= */}

        {showCreate && (
          <UserForm
            onSubmit={handleCreate}
            onCancel={() => setShowCreate(false)}
            allowedRoles={allowedRoles}
          />
        )}

        {editTarget && (
          <EditUserForm
            user={editTarget}
            onSubmit={handleUpdate}
            onCancel={() => setEditTarget(null)}
            allowedRoles={allowedRoles}
            isSelfEdit={currentUser?.id === editTarget.id}
          />
        )}

        {pwdTarget && (
          <ChangePasswordForm
            userId={pwdTarget.id}
            username={pwdTarget.username}
            onSubmit={handleChangePassword}
            onCancel={() => setPwdTarget(null)}
          />
        )}
      </main>
    </div>
  );
}
